import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from './hooks'; // Assuming you have these hooks configured
import { getHostName, getOrigin } from '../common/services/common.service';
import moment from 'moment';
import PageLoader from '../components/PageLoader';
import { settings } from '../redux/settings/actions';
import { guestToken } from '../redux/auth/actions';

export const GuestTokenProvider = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);  // Track loading state


  useEffect(() => {
    const getGuestToken = async () => {
      try {
        await dispatch(guestToken({
          loginData: [
            {
              "Context": {
                "domain": "string",
                "core_version": "string",
                "bap_id": getHostName(),
                "bap_uri": getOrigin(),
                "bpp_id": "string",
                "bpp_uri": "string",
                "city": "string",
                "country": "string",
                "action": "string",
                "transaction_id": "string",
                "message_id": "string",
                "timestamp": moment.utc(),
                "ttl": "string",
                "Subscription": "MoveX",
                "Domain": "Mobility",
                "SubDomains": [],
                "Network": "RAPCustomer",
                "Application": "Customer",
                "Channel": "CSP"
              },
              "Message": {
                "AccountType": "RAPCustomer"
              }
            }
          ]
        }));
        dispatch(settings.set({
          isGuestTokenReady: true
        }))
        setLoading(false);
      } catch (e: any) {
        dispatch(settings.set({
          isGuestTokenReady: false
        }))
        setLoading(false);
      }
    };

    // Trigger the guest token fetch
    (async () => {
      dispatch(settings.set({
        isGuestTokenReady: false
      }))
      await getGuestToken();
    })();

  }, [dispatch]);

  if (loading) {
    return <PageLoader />
  }

  return (
    <>
      {children}
    </>
  );
};
